import AddPricebookBtn from "./AddPricebookBtn";

export default AddPricebookBtn;



// WEBPACK FOOTER //
// ./src/components/Pricebook/AddPricebookBtn/index.js